// extracted by mini-css-extract-plugin
export default {"imageWrapper":"eH-z","hovered":"fH-z","hoverImage":"gH-z","mainImage":"hH-z","imageNoBackground":"iH-z","fullSizeImage":"jH-z"};